// components/TamaGawdtchiHealth.js
import classNames from 'classnames'
import { useEffect, useRef, useState } from 'react'
import usePolygonBlockNumber from 'web/hooks/usePolygonBlockNumber'
import useTamagawdtchi from 'web/hooks/useTamagawdtchi'
import useMyBoons from 'web/hooks/useMyBoons'
import styles from './TamaGawdtchiHealth.module.css'

const TamaGawdtchiHealth = ({ gawdId }) => {
  const [hasActiveBoon, setBoonActivated] = useState<boolean>(false)
  const polygonBlock = usePolygonBlockNumber(false)
  const myBoons = useMyBoons()

  useEffect(() => {
    setBoonActivated(myBoons.active.length > 0)
  }, [myBoons, polygonBlock])

  const tamagawdtchi = useTamagawdtchi(gawdId)
  let progress = tamagawdtchi?.getHealth() * 100

  return (
    <div className="relative rounded-lg bg-black h-1 w-1/2 md:w-3/4 m-auto">
      <span
        style={{ width: `${progress}%` }}
        className={classNames(
          `transition-all duration-700 ease-out absolute top-0 left-0 bottom-0 rounded-lg`,
          hasActiveBoon ? styles.boonActivated : 'bg-red-500'
        )}
      >
        &nbsp;
      </span>
      <span className="absolute inset-0 text-center z-1 text-sm"></span>
    </div>
  )
}
export default TamaGawdtchiHealth
